import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	rootTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	rootTitle: {
		id: 'onboarding-quickstart-core.services.tasks.config.plan.root-title',
		defaultMessage: 'Quickstart',
		description: 'Initial title of Quickstart for Jira Plan',
	},
});
